/**
 * This selector will use index as the selection key. Instead of supplying
 * a component to use for state, this will take methods that can get the
 * items, get the current selected, and set the current selected object.
 * An example of this might look like:
 * <code>
 * this.selector = new IndexSelector( { 
 *    useMeta : true,
 *    getItems : ( ) => { return this.props.model.getAll( this.props.value ) || [] }, 
 *    getSelected : ( ) => { return this.state.selected },
 *    setSelected : ( selected, cb ) => { this.setState( { selected }, cb ) }
 *  } )
 * </code>
 */
export default class IndexSelector {
  constructor({
    getItems,
    setSelected,
    getSelected,
    allowSelect,
    useMeta
  }) {
    this.getItems = getItems;
    this.getSelected = getSelected;
    this.setSelected = setSelected;
    this.allowSelect = allowSelect;
    this.useMeta = useMeta;
  }
  isSelected = item => {
    const idx = this.getSelected();
    const items = this.getItems();
    if (idx == null || idx < 0 || idx >= items.length) {
      return false;
    }
    return item === items[idx];
  };
  onSelect = event => {
    const items = this.getItems();
    const item = event.value;
    const meta = event.sourceEvent && event.sourceEvent.metaKey;
    const selected = this.isSelected(item);
    const cb = event.onSelect ? () => {
      event.onSelect(item);
    } : null;
    if (this.useMeta && meta && selected) {
      // Handle emptying the selection
      if (this.allowSelect == null || this.allowSelect(null) !== false) {
        this.setSelected(null, cb);
      }
      return;
    }
    if (selected) {
      // already selected
      return;
    }
    const nIdx = items.indexOf(item);
    if (this.allowSelect == null || this.allowSelect(item) !== false) {
      this.setSelected(nIdx, cb);
    }
  };
}